// TODO: get rid of this
import React from 'react';
import { transformHTMLParserLinks } from '../../../../../utils/rewriteLink/rewriteLink';
import './AlreadyAMember.css';
import { usePageProperties } from '../../../providers/PagePropertiesProvider';
import { Button } from '../../../../../importCL';

export default function AlreadyAMember() {

    const { signInQuestionText, signInQuestionUrl, pqHomeRedirectUrl } = usePageProperties();

    return (
        <Button
            className='Pqde-AlreadyAMember__cta'
            variant='ghosted-dark'
            size='medium'
            href={signInQuestionUrl ?? pqHomeRedirectUrl}
        >
            {transformHTMLParserLinks(signInQuestionText)}
        </Button>
    );
}
